import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () =>
    import(/* webpackChunkName: "CasinoGameTrailerWidget" */ './CasinoGameTrailerWidget'),
  modules: ['./CasinoGameTrailerWidget'],
  loading: () => <div />
});

export default LoadableWidget;
